import { Injectable } from '@angular/core';
import { StringUtil } from '@ddt-web/generic-utils';

@Injectable()
export class ChartService {

	public getDefaultConfig(chartType: string, chartContainer: HTMLElement, height: number, width: number, chartTitle: string): any {
		if (chartTitle && chartTitle.length > 50) {
			chartTitle = StringUtil.splitSpaceLessStringForChart(chartTitle, 14).substring(0, 50) + '...';
		}
		return {
			chart: {
				height: height || chartContainer.offsetWidth,
				width: width || chartContainer.offsetWidth,
				type: chartType,
				renderTo: chartContainer,
				spacing: 0,
				marginTop: 5,
				backgroundColor: null,
				style: {
					fontFamily: '"FortBold", Arial, sans-serif'
				}
			},
			credits: {
				enabled: false
			},
			exporting: {
				chartOptions: {
					chart: {
						backgroundColor: '#fff'
					}
				}
			},
			legend: {
				enabled: false
			},
			navigation: {
				buttonOptions: {
					enabled: false
				}
			},
			navigator: {
				enabled: false
			},
			plotOptions: {
				line: {
					marker: {
						enabled: false
					}
				},
				bubble: {
					maxSize: 25
				}
			},
			scrollbar: {
				enabled: false
			},
			title: {
				text: chartTitle || null
			}
		};
	}

}
